module.exports = __webpack_public_path__ + "fdf11cfc3548b7e7d469261bf42d2675.gif";